import { c as _c } from "react/compiler-runtime";
import { ProjectCard } from "@components/common/project-card/project-card";
import { DEFAULT_PROJECTS_SORT_BY } from "@components/projects/projects-sort-constants";
import { useCompanyId } from "@context-providers/company-id-provider";
import { Box } from "@mui-wrapper";
import { cardWidth } from "@utils/ui-utils";

/** Popup content rendered when a map marker is clicked. */
export function ProjectMarkerPopupContent(t0) {
  const $ = _c(4);
  const {
    project
  } = t0;
  const companyId = useCompanyId();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: cardWidth.sm
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== companyId || $[2] !== project) {
    t2 = <Box sx={t1}><ProjectCard companyId={companyId} project={project} numberOfProjects={1} sortBy={DEFAULT_PROJECTS_SORT_BY} isThumbnailLink={true} /></Box>;
    $[1] = companyId;
    $[2] = project;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}